import $ from 'jquery';
import storageManager from '@utils/storage-manager';

/**
 * Widgets widgets to be executed
 * @type {{}}
 */
const widgets = [];

/**
 * Cached variables - cache once, run everywhere
 * @type {any}
 */
/* eslint no-undef: 0 */
const $document = $(document);
const $body = $('body');
const $window = $(window);

/**
 * Register widgets widgets and run.
 * We are not doing it inside widgets so we have full control over it.
 * Good for testing, mocking and executing selectively.
 *
 * @param name
 * @param module
 */
const register = (modules) => {
    modules.forEach((module) => {
        widgets.push(module);
    });
};

const logger = (method, ...args) => {
    /* eslint no-console: 0 */
    console.log.call(console, `[${method}]`, ...args);
};

/**
 * Run all registered widgets widgets
 */
const run = (config = {}) => {
    const log = config.env !== 'production' ? logger : () => {};

    /* params to be injected into each `widgets` module */
    const params = { $document, $body, $window, log, config };

    const darkMode = storageManager.getDarkMode();
    $('body').toggleClass('dark-mode', darkMode === 'true');

    $(document).on(storageManager.DARK_MODE_EVENT, (event, value) => {
        $('body').toggleClass('dark-mode', value === 'true');
    });

    widgets.forEach((widget) => {
        const initPresent = !!widget.init;

        if (initPresent) {
            widget.init(params);
        }

        if (!initPresent && (config.env !== 'production')) {
            log('error', 'Malformed widget\r\n', widget);
        }
    });

    log('info', 'Initialized RM.pl 2.0');
    log('info', 'Config', config);
};

export default { run, register };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/bootstrap.js